<template>
  <div class="contents">
    <audio
      id="bgmSound"
      :src="`${commonPath}sounds/bgm.mp3`"
      loop="true"
    />
    <div class="top-menu">
      <img
        class="top-menu-logo"
        :src="`${commonPath}${menuContent.logoPath}`"
        @click="openNewWindow(menuContent.homeUrl, false)"
      >
      <div class="top-menu-right">
        <div
          class="menu-button box-btn entry-btn"
          @click="openNewWindow(menuContent.docUrl)"
        >
          <div class="button-content">
            <!-- // 学校アイコン <i class="fas fa-school"></i> -->
            <!-- <i class="fas fa-hotel"></i> -->
            <p class="box-btn-text">
              エントリー
            </p>
          </div>
        </div>
        <div
          class="menu-button box-btn"
          @click="openNewWindow(menuContent.contactUrl)"
        >
          <div class="button-content">
            <!-- // アンケートアイコン <i class="far fa-clipboard"></i> -->
            <!-- <i class="fas fa-envelope"></i> -->
            <p class="box-btn-text">
              詳しく知る
            </p>
          </div>
        </div>
        <div
          class="menu-button circle-btn"
          @click="(bgmStatus)?setBgmStatus(false):setBgmStatus(true);"
        >
          <div class="button-content">
            <template v-if="bgmStatus">
              <i class="fas fa-volume-up" />
              <p class="circle-btn-text">
                ON
              </p>
            </template>
            <template v-else>
              <i class="fas fa-volume-mute" />
              <p class="circle-btn-text">
                OFF
              </p>
            </template>
          </div>
        </div>
      </div>
    </div>
    <div class="vr-scene">
      <a-scene id="scene">
        <a-assets
          v-if="pageId === undefined"
          id="assets-area"
        >
          <video
            v-for="(face, index) in faceList"
            :id="index"
            :key="index"
            :src="`/face/${face}`"
            preload="auto"
            playsinline
            autoplay
            muted
            loop
          />
          <video
            v-if="loadFlag"
            id="screenVideo"
            :src="`${commonPath}movie/B1-movie.mp4`"
            playsinline
            autoplay
            muted
            loop
            @loadeddata="onloadedVideo"
          />
        </a-assets>
        <RoomScene
          ref="room"
          :image-route-path="routePath + 'images/'"
          :glb-route-path="routePath + 'glb/'"
          :json-data="jsonData"
          @setGlbData="setGlbData"
          @loadFlag="loadFlag=true"
          @setConfirmWindow="setConfirmWindow"
          @positionChanged="positionChanged"
        />
        <!-- 室内の場合の2Fの床 -->
        <a-plane
          v-if="jsonData.modelName === 'inside'"
          id="inside-prevFloor"
          static-body
          position="7.5 3.2 13"
          rotation="270 0 0"
          width="5"
          height="5"
          material="opacity:0"
        />
        <!-- 屋外の場合の階段上の床 -->
        <a-plane
          v-if="jsonData.modelName === 'outside'"
          id="outside-prevFloor"
          static-body
          position="0 1.25 -4"
          rotation="270 0 0"
          width="13"
          height="7.5"
          material="opacity:0"
        />
        <!-- アバター -->
        <a-entity
          v-if="pageId === undefined"
          id="avatar-parts"
        >
          <a-entity
            v-for="(avatar, index) in avatarData"
            :id="index"
            :key="index"
            :position="avatar.position"
            :rotation="avatar.rotation"
            @click="setConfirmWindow(index)"
          >
            <a-entity
              :gltf-model="avatar.model"
              rotation="0 180 0"
            />
            <a-video
              v-if="avatar.type === 'video'"
              :src="`#${avatar.face}`"
              position="0 1.03 0.175"
              width="0.6"
              height="0.34"
            />
            <a-image
              id="bubble-speech"
              :src="`${routePath}images/speech-bubble.png`"
              position="0 1.7 0"
              rotation="0 0 0"
              width="1"
              height="0.4"
            />
            <a-image
              id="text-inquiry"
              :src="`${routePath}images/${jsonData.linkList[index].image}`"
              position="0 1.7 0.02"
              rotation="0 0 0"
              width="1"
              height="0.4"
            />
            <a-cone
              position="0 1.36 0"
              rotation="180 0 0"
              color="#FF4333"
              radius-bottom="0.05"
              radius-top="0"
              height="0.1"
              animation="property:object3D.position.y; to:1.42; dir:alternate; dur:1000; loop:true"
            />
          </a-entity>
          <!-- 動画 -->
          <a-video
            v-if="loadFlag"
            src="#screenVideo"
            position="0 2.57 -9.74"
            width="7.68"
            height="4.32"
          />
        </a-entity>
      </a-scene>
    </div>
    <LoadingView v-if="!loadFlag" />
    <SoundPermission
      v-if="soundPermissionFlag"
      @sound-permission="clickSoundPermission()"
    />
    <ConfirmWindow
      v-if="confirmWindowFlag"
      :target-url="targetUrl"
      :window-open="windowTabFlag"
      @close-window="confirmWindowFlag=false"
    />
  </div>
</template>

<script>
import utilsMixin from '../mixins/utils'
import LoadingView from '../components/LoadingView'
import SoundPermission from '../components/SoundPermission'
import ConfirmWindow from '../components/ConfirmWindow'
import RoomScene from '../components/RoomScene'
import settingJson from '../assets/setting-willof-work.json';

export default {
  name: 'WillOfWorkView',
  components: {
    RoomScene,
    LoadingView,
    SoundPermission,
    ConfirmWindow
  },
  mixins: [utilsMixin],
  props: {},
  data() {
    return {
      title: 'ウィルオブワーク',  // ページタイトル
      description: 'ウィルオブワーク メタバースオフィスです。',  // ページ説明
      loadFlag: false,                                    // ロード画面用フラグ
      confirmWindowFlag: false,                           // 遷移先確認画面表示フラグ
      soundPermissionFlag: false,                         // 音声許可ウィンドウ表示フラグ
      targetUrl: '',                                      // 遷移先URL
      windowTabFlag: true,                                // 別タブ起動フラグ true->別タグ
      allJsonData: settingJson,                           // 全てのページの設定情報
      jsonData: '',                                       // ページごとの設定情報
      pageId: this.$route.params.page,                    // ページID
      prevPageId: this.$route.query.prev,                 // 一つ前のページID
      commonPath: '/assets/willof-work/',               // 各データの共通パス
      routePath: '/assets/willof-work/',                // 各データのルートパス
      secondaryRoutePath: '/assets/willof-work-page/',  // 子階層の各データのルートパス
      glbData: {},                                        // 子Vueで取得したGLBデータ
      delWarpGlbList: [],                                 // ワープゾーンの土台GLB(使っていないものは削除するために保持)
      faceList: {   // 顔動画
        reception: 'reception.mp4',
        wavehands: 'wavehands.mp4'
      },
      avatarData: { // アバターの情報
        'info': {  // シアター内のお問合せアバター
          model: '/glb/simple-avatar/office-woman.glb',
          type: 'video',
          face: 'wavehands',
          position: '-5.92 0 4.47',
          rotation: '0 90 0'
        },
        'reserve': {  // 学校内のお問合せアバター
          model: '/glb/simple-avatar/job-bus-guide.glb',
          type: 'video',
          face: 'reception',
          position: '-11.3 0 -7.45',
          rotation: '0 0 0'
        }
      },
      menuContent: {
        logoPath: 'images/menu-logo.png',
        homeUrl: '/#/willof-work',
        docUrl: 'https://job.mynavi.jp/27/pc/search/corp220143/is.html',
        contactUrl: 'https://willof-work.co.jp/sa/employment/'
      },
      windowActive: true, // ウィンドウがアクティブかどうかのフラグ
      bgmStatusBeforeDeactivation: true, // ウィンドウが非アクティブだったときのBGMの状態
      jsonRotationY: 0, // rigカメラのY軸回転角度
      roomRig: null, // カメラリグの参照
      roomCamera: null // カメラの参照
    }
  },
  computed: {
    firstAccess() {
      // 初回アクセスフラグを取得
      return this.$store.getters['CampusStatus/getFirstAccess'];
    },
    bgmStatus() {
      // BGM許可ステータスを取得
      return this.$store.getters['CampusStatus/getBgmStatus'];
    },
    isTouchDevice() {
      // タッチデバイス判定を取得
      return this.$store.getters['CampusStatus/getTouchDeviceStatus'];
    }
  },
  watch: {
    /*******************************************
     * BGM許可ステータスに変更がある場合
     ******************************************/
    async bgmStatus(newBool) {
      if (newBool !== this.bgmStatus) {
        // BGMコントロール処理を呼び出し
        this.setBgmStatus(newBool);
      }
    },
    /*******************************************
     * Loadフラグが更新されたらアニメーションを設定
     ******************************************/
    async loadFlag(newBool) {
      // 音声許可ポップアップを表示する判定
      if (this.firstAccess) this.soundPermissionFlag = true;
      if(newBool) {
        for (let property in this.glbData.animation) {
          // アニメーションを設定
          await this.setAnimation(property);
        }
        // リンク情報の存在しないワープGLBを非表示
        this.delWarpGlbList.forEach((elem, index) => {
          let removeGlbWarp = document.getElementById(elem);
          removeGlbWarp.setAttribute('visible', false);
        });
      }
      // 子階層のページの時はBGM処理を呼び出し
      if(this.pageId) this.setBgmStatus(this.bgmStatus);
    },
    /*******************************************
     * ウィンドウのアクティブ状態の変更を監視
     ******************************************/
     windowActive(newActiveState) {
      // ウィンドウが非アクティブになったとき
      if (!newActiveState) {
        // ウィンドウが非アクティブになる直前のBGMの状態を保存
        this.bgmStatusBeforeDeactivation = this.bgmStatus;
        // BGMをミュートにする
        this.setBgmStatus(false);
      } else {
        // ウィンドウがアクティブになったとき
        // ウィンドウが非アクティブだったときのBGMの状態に戻す
        this.setBgmStatus(this.bgmStatusBeforeDeactivation);
      }
    }
  },
  created() {
    // 出現位置を設定(建物名を設定) ※※※Custom※※※
    this.setRoomRig('office', 'willof-work');
  },
  mounted() {
    // タイトルと説明、OGPを設定
    this.changePageContent();
    // ページがメインフロアの場合、顔動画を再生
    if(this.pageId === undefined) {
      for(const video in this.faceList){
        let videoElement = document.getElementById(video);
        videoElement.play();
      }
    }
    // コントロールボタン操作に必要な情報を設定
    this.jsonRotationY = this.jsonData.rig.rotation.y; // jsonDataからrigのY軸回転角度を取得しjsonRotationYに設定
    this.roomRig = this.$refs.room.$refs.rig; // roomコンポーネントからrigエレメントを取得しroomRigに設定
    this.roomCamera = this.$refs.room.$refs.camera; // roomコンポーネントからcameraエレメントを取得しroomCameraに設定
    /*******************************************
     * ウィンドウのフォーカスイベントを監視
     ******************************************/
     window.addEventListener('focus', () => {
      this.windowActive = true;
    });
    // ウィンドウのブラーイベントを監視
    window.addEventListener('blur', () => {
      this.windowActive = false;
    });
  },
  methods: {
    /*******************************************
     * ワープゾーンのポジション設定
     ******************************************/
    positionChanged(newPosition) {
      // 設定されているワープゾーンの数だけ繰り返しチェック
      for (let property in this.jsonData.warpList) {
        // 設定ファイルからワープゾーンのポジションを取得
        let xWarpSpot = Math.ceil(this.jsonData.warpList[property].position.x);
        let yWarpSpot = Math.ceil(this.jsonData.warpList[property].position.y);
        let zWarpSpot = Math.ceil(this.jsonData.warpList[property].position.z);
        // ワープゾーンに来たら確認ポップアップを起動(原点から±1m以内の範囲)
        if(
          (newPosition.x >= xWarpSpot - 1 && newPosition.x <= xWarpSpot + 1) &&
          (newPosition.y >= yWarpSpot - 1 && newPosition.y <= yWarpSpot + 1) &&
          (newPosition.z >= zWarpSpot - 1 && newPosition.z <= zWarpSpot + 1)
        ) {
          // ポップアップの処理を呼び出し
          this.setWarpConfirmWindow(property);
        }
      }
    },
    /*******************************************
     * OGPを設定
     ******************************************/
    // ogImagePathを生成する
    ogImagePath() {
      const uri = new URL(window.location.href);
      if(this.pageId === undefined) {
        return `${uri.origin}${this.routePath}images/og_image.png`;
      } else {
        return `${uri.origin}${this.secondaryRoutePath}images/og_image-${this.pageId}.png`;
      }
    },
    /*******************************************
     * BGM許可をクリックした時
     ******************************************/
     clickSoundPermission() {
      // 許可フラグを書き換え
      this.soundPermissionFlag = false;
      // 初回アクセスの場合は書き換え
      if(this.firstAccess) this.$store.dispatch('CampusStatus/setFirstAccess', false);
      this.setBgmStatus(true);
    },
    /*******************************************
     * 動画のロードが完了したとき
     ******************************************/
     async onloadedVideo() {
      let screenVideo = document.getElementById('screenVideo');
      screenVideo.muted = true;
      await screenVideo.play();
      this.setBgmStatus(this.bgmStatus);
    },
    /*******************************************
     * audioかvideoかの処理を振り分け
     ******************************************/
    setBgmStatus(newBool) {
      this.$store.dispatch('CampusStatus/setBgmStatus', newBool);
      if(this.pageId === undefined) {
        screenVideo.volume = 0.2;
        screenVideo.muted = !newBool;
        // ミュート解除で止まってしまうときがあるので判定する
        if(screenVideo.paused) {
          // ミュートで再生して許可フラグを再度出す
          screenVideo.muted = true;
          screenVideo.play();
          this.soundPermissionFlag = true;
        }
      } else {
        // BGMコントロール処理を呼び出し
        this.bgmControl();
      }
    },
    /*******************************************
     * 音楽のBGMの再生処理
     * フラグに変更があれば再生or一時停止処理
     ******************************************/
    async bgmControl() {
      const bgmSound = document.getElementById('bgmSound');
      if(Boolean(this.bgmStatus)) {
      // 再生処理
        try {
          // BGMを再生
          await bgmSound.play();
        } catch(err) {
          // 再生に失敗した場合はフラグを書き換え
          this.setBgmStatus(false);
          this.soundPermissionFlag = true;
        }
      } else {
        // 一時停止処理
        bgmSound.pause();
      }
    },
    /*******************************************
     * 子から受け取った建物データを設定
     ******************************************/
    setGlbData(glbData) {
      this.glbData = glbData;
    },
    /*******************************************
     * 別タブでURLを起動
     ******************************************/
    openNewWindow(target, windw = true) {
      if(windw) {
        window.open(target);
      } else {
        location.href = target
        location.reload();
      }
    },
    /*******************************************
     * 画面遷移のConfirm画面呼び出し
     ******************************************/
    setConfirmWindow(target) {
      // 設定ファイルからURLを取得
      this.targetUrl = this.jsonData.linkList[target].url;
      // confirmウィンドウを起動
      this.confirmWindowFlag = true;
    },
    /*******************************************
     * ワープのConfirm画面呼び出し
     ******************************************/
     setWarpConfirmWindow(target) {
      // URL形式
      if (this.jsonData.warpList[target].url.indexOf('://') === -1) {
        // 自サイトの場合ホストを設定
        this.targetUrl = window.location.protocol + '//' + window.location.host + '/#';
        this.targetUrl += this.jsonData.warpList[target].url;
        // pageIDがある場合はパラメーターに設定
        if(this.pageId !== undefined) this.targetUrl += '?prev=' + this.pageId;
        this.windowTabFlag = false;
      } else {
        // 他サイトの場合はそのままURLを設定
        this.targetUrl =  this.jsonData.warpList[target].url;
      }
      // confirmウィンドウを起動
      this.confirmWindowFlag = true;
    },
    /*******************************************
     * パーツごとにアニメーションを設定する
     ******************************************/
    setAnimation(animationName) {
      let animationElement = document.getElementById(animationName);
      // ドア左の開くアニメーション
      if (animationElement.id === 'animation-door-l') {
        animationElement.setAttribute('animation', 'property: object3D.position.x;to: -1.1;dir: alternate;dur: 2000;loop: false');
      }
      // ドア右の開くアニメーション
      if (animationElement.id === 'animation-door-r') {
        animationElement.setAttribute('animation', 'property: object3D.position.x;to: 1.1;dir: alternate;dur: 2000;loop: false');
      }
      // 建物内の矢印を前後に動かす
      if (animationElement.id === 'animation-nobody-arrow') {
        animationElement.setAttribute('animation', 'property: object3D.position.z;to: -0.5;dir: alternate;dur: 1000;loop: true');
      }
      // ワープ(渦巻)のアニメーション
      if(animationElement.id.indexOf('animation-warp') !== -1) {
        // // 原点にあるものは削除(削除するとmassエラーが出るため)
        // animationElement.remove();
        // 原点にあるものは非表示
        animationElement.setAttribute('visible', 'false');
        // glbファイルの保存先URLを取得
        const glbWarpPath = this.glbData.animation[animationElement.id].path;
        // warp glbのファイル名の最後の文字を取得(サイズが一致しない場合は表示しない判定に利用)
        const glbWarpSize = animationElement.id.charAt(animationElement.id.length -1);
        // ワープゾーン(土台)のGLB名を全て取得(すでに設定されている場合は取得しない)
        if(this.delWarpGlbList.length === 0) {
          this.delWarpGlbList = Object.keys(this.glbData.common).filter( (key) => {
            return key.match(/^nobody-warp-[0-9]/);
          });
        }
        // ワープGLBを配置する処理
        const scene = document.getElementById('scene');
        // 設定ファイルのワープリストが存在するだけ繰り返す
        for(let property in this.jsonData.warpList) {
          let warpData = this.jsonData.warpList[property];
          // ワープのサイズが一致しない場合は後続処理を行わない
          let warpSize = warpData.size.charAt(0);
          if(glbWarpSize !== warpSize) continue;
          // リンク先情報がある場合は削除リストから除外
          this.delWarpGlbList = this.delWarpGlbList.filter(function(glb) {
            return !glb.match(property);
          });
          // ワープのentityを作成して配置
          let warp = document.createElement('a-entity');
          warp.setAttribute('id', property);
          warp.setAttribute('static-body', 'type: dynamic; mass: 5; shape:none;');
          warp.setAttribute('gltf-model', glbWarpPath);
          warp.setAttribute('position', warpData.position);
          warp.setAttribute('animation', 'property: rotation; from: 0 0 0; to: 0 360 0; dur: 800; easing: linear; loop: true');
          scene.appendChild(warp);
        }
      }
    }
  }
}
</script>

<style scoped>
.contents {
  height: 100vh;
}
.vr-scene {
  height: 92vh;
}
.top-menu {
  height: 8vh;
  min-height: calc(50px + 10px);
  display: flex;
}
.top-menu-logo {
  cursor: pointer;
}
.top-menu-right {
  position: relative;
  display: flex;
  padding: 5px 0;
  margin:auto 10px auto auto;
}
.menu-button{
  background-color: #ffffff;
  margin:auto 10px auto 0;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition: all ease 0.2s;
}
.box-btn {
  color: #4893F0;
  font-weight: bold;
  border: 1px solid #4893F0;
  border-radius: 2px;
  padding: 12px 25px;
}
.box-btn:hover {
  color: #fff;
  background-color: #EFBE38;
  border-color: #EFBE38;
}
.entry-btn {
  color: #ffffff;
  background-color: #4893F0;
}
.circle-btn {
  width: 50px;
  line-height: 0.85em;
  border: thin solid #202020;
  border-radius: 50%;
}
.circle-btn:hover {
  color: #fff;
  background-color: #202020;
}
.circle-btn-text {
  font-size: 0.35em;
  white-space: nowrap;
}
@media screen and (max-width:428px){
  /* SP 縦画面 */
  .box-btn {
    max-width: 100px;
    font-size: 80%;
    line-height: 1;
    padding: 12px 15px;
  }
}
</style>